import router from "../router"

let eventoDeRota;

class RouterUtils {
    constructor() {}

    iniciarEventoDeRouter() {
        eventoDeRota = document.addEventListener("ce-alt-econt-menu-navegar",
            (event) => {
                if (event?.detail) {
                    const endereco = event.detail.endereco;
                    router.push(endereco)
                }
            },
            false
        );
    }

    _carregarNovaRota(endereco) {
        router.push(endereco);
    }

    async _carregarNovaRotaAsync(endereco, callback = () => {}) {
        await router.push(endereco);
        callback()
    }

    _substituiRota(endereco) {
        router.replace(endereco)
    }

    _carregarUrl(endereco) {
        window.location = endereco
    }

    removerEventoDeRouter() {
        document.removeEventListener("ce-alt-econt-menu-navegar", eventoDeRota);
    }

}

export const routerUtils = new RouterUtils()